(() => {
  const SUBMITTING = 'data-pitb-submitting';
  const LOCKED = 'data-pitb-click-locked';

  /** AJAX / storefront commerce forms must not be permanently locked. */
  const isCommerceForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.matches('[data-pitb-search-form]') || form.closest('[data-pitb-search-form]')) {
      return true;
    }
    if (form.closest('product-form, quick-add-modal, cart-items, cart-drawer, cart-notification')) {
      return true;
    }
    const action = String(form.getAttribute('action') || form.action || '').toLowerCase();
    return (
      action.includes('/cart/add') ||
      action.includes('/cart/change') ||
      action.includes('/cart/update') ||
      action.includes('/cart') ||
      action.includes('/checkout')
    );
  };

  const isIgnoredControl = (el) => {
    if (!el || !el.matches) return true;
    if (el.matches('[data-pitb-allow-multi-click]')) return true;
    if (el.matches('.quantity__button, .quantity__input')) return true;
    if (el.matches('.pitb-pc__atc, .pitb-pdp__atc, .product-form__submit, [name="add"]')) return true;
    if (el.matches('[data-pitb-timeslot], [data-pitb-date-trigger], [data-pitb-pickup-date-day], [data-pitb-slot-option], [data-pitb-filters] a, [data-filter]')) {
      return true;
    }
    return false;
  };

  const submitControls = (form) =>
    Array.from(
      form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])')
    );

  const lockForm = (form) => {
    if (!form || form.getAttribute(SUBMITTING) === '1') return false;
    form.setAttribute(SUBMITTING, '1');
    submitControls(form).forEach((btn) => {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-submitting');
    });
    return true;
  };

  const lockControl = (el) => {
    if (!el || el.getAttribute(LOCKED) === '1') return false;
    el.setAttribute(LOCKED, '1');
    if ('disabled' in el) el.disabled = true;
    el.setAttribute('aria-busy', 'true');
    el.classList.add('is-submitting');
    return true;
  };

  // Full-page forms only (contact, account, etc.) — not cart/ATC AJAX forms.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (isCommerceForm(form)) return;

      if (form.getAttribute(SUBMITTING) === '1') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      lockForm(form);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!target || !target.closest) return;

      const control = target.closest(
        'button[type="submit"], input[type="submit"], button:not([type]), form button'
      );
      if (!control || isIgnoredControl(control)) return;

      const form = control.form || control.closest('form');
      if (form && isCommerceForm(form)) return;

      const isSubmit =
        control.matches('button[type="submit"], input[type="submit"], button:not([type])') ||
        (form && control.type === 'submit');
      if (!isSubmit) return;

      if (form && form.getAttribute(SUBMITTING) === '1') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (control.getAttribute(LOCKED) === '1' || control.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // Only lock after confirming this is a classic form submit control.
      if (form) {
        lockControl(control);
        lockForm(form);
      }
    },
    true
  );
})();
